
interface BaseMedicationInput {
  type: "médicament";
  nom: string;
  posologie: string;
  date: string;
  heure: string;
}

interface BaseAppointmentInput {
  type: "rendez-vous";
  objet: string;
  lieu?: string;
  date: string;
  heure: string;
}

interface NotificationOutput {
  type: "médicament" | "rendez-vous";
  titre: string;
  message: string;
  date: string;
  heure: string;
}

type NotificationInput = BaseMedicationInput | BaseAppointmentInput;

export const generateNotification = (input: NotificationInput): NotificationOutput => {
  if (input.type === "médicament") {
    return {
      type: "médicament",
      titre: "Prise de médicament",
      message: `Pensez à prendre ${input.nom} ${input.posologie} maintenant.`,
      date: input.date,
      heure: input.heure
    };
  }

  return {
    type: "rendez-vous",
    titre: input.objet,
    message: `Votre ${input.objet}${input.lieu ? ` à ${input.lieu}` : ""} commence à ${input.heure}.`,
    date: input.date,
    heure: input.heure
  };
};
